import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recherches',
  templateUrl: './recherches.component.html',
  styleUrls: ['./recherches.component.css']
})
export class RecherchesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
